import { KeyboardEventHandler } from "react";
import { JSONContent } from "@tiptap/react";

import { RichTextEditorInput } from "@/components/RichTextEditorInput";

import { tiptap } from "@/lib/tiptap";

export const RichTextEditorInputWithMention = ({
  editorContentClasses,
  onChange,
  onKeyDown,
  value,
}: {
  editorContentClasses?: string;
  onChange: (value: JSONContent) => void;
  onKeyDown?: KeyboardEventHandler;
  value: JSONContent;
}) => {
  return (
    <RichTextEditorInput
      editorContentClasses={editorContentClasses}
      // ! This needs to be kept in sync with the extensions in the `tiptap` file (specifically the `jsonToHtmlFn` function).
      extensions={tiptap.generateMentionExtensions()}
      mode={{
        onChange: onChange,
        type: "json",
        value: value,
      }}
      onKeyDown={onKeyDown}
    />
  );
};
